import { Component, ViewChild, ElementRef } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ProjectService } from 'src/app/services/project.service';
import { v4 as uuid } from 'uuid';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subscription, map } from 'rxjs';
import { Project } from 'src/app/models/project.model';
import { UploadService } from 'src/app/services/upload.service';
import { ProjectCategoryService } from 'src/app/services/project-category.service';
import { ProjectCategory } from 'src/app/models/project-category.model';

@Component({
  selector: 'app-project-create',
  templateUrl: './project-create.component.html',
  styleUrls: ['./project-create.component.css'],
})
export class ProjectCreateComponent {
  showSpinner: boolean = false;

  logoFile: File[] = [];
  imageProject: File[] = [];
  sponsorImages: File[] = [];
  partnersImages: File[] = [];
  categories: ProjectCategory[] = [];
  categorySubscription$: Subscription;

  array: any = [
    { id: 1, name: 'first text' },
    { id: 2, name: 'second text' },
  ];

  projectForm: FormGroup;
  projectPreview$: Observable<Project>;

  // PREVIEW IMAGES
  previewLogoProjectTogggle: boolean = false;
  previewProjectImageTogggle: boolean = false;
  previewSponsorImageTogggle: boolean = false;
  previewPartnersImageTogggle: boolean = false;

  previewLogoProject = '';
  previewProjectImage = '';
  previewSponsorImage: any[] = [];
  previewParnersImage: any[] = [];

  constructor(
    private fb: FormBuilder,
    private projectService: ProjectService,
    private uploadService: UploadService,
    private router: Router,
    private categoryService: ProjectCategoryService
  ) {}

  ngOnInit(): void {
    this.categoryService.getAllCategorys();
    window.scrollTo(0, 0);
    this.categorySubscription$ =
      this.categoryService.projectCategorySubject$.subscribe(
        (response: ProjectCategory[]) => {
          console.log('All project categories', response);
          this.categories = response;
          this.array = response;
        },
        (error) => {
          console.log('An error occured: ' + error);
        }
      );
    this.initForm();

    this.projectPreview$ = this.projectForm.valueChanges.pipe(
      map((formValue) => ({
        ...formValue,
      }))
    );
  }

  initForm() {
    this.projectForm = this.fb.group({
      title: [null, Validators.required],
      content: [null, Validators.required],
      /* category_id: ['', Validators.required], */
      start_date: [],
      end_date: [],
      location: [],
      project_icon_url: [],
      project_image_url: [],
      sponsor_images_url: [],
      partners_images_url: [],
      director: [],
      code: [],
    });
  }

  async submitForm() {
    this.showSpinner = true;
    console.log(
      'Available to upload....comes>>>>>>>>',
      this.logoFile,
      this.imageProject,
      this.sponsorImages,
      this.partnersImages
    );

    if(this.logoFile.length !== 0) {
      const logoPayload = this.cloudinaryRequestFormatter(this.logoFile[0]);
      let logoResponse: any = await this.sentToCloudinary(logoPayload)
      console.log('Logo response', logoResponse);

      this.projectForm.get('project_icon_url')?.patchValue(logoResponse.secure_url);
      this.projectForm.get('project_icon_url')?.updateValueAndValidity();
    }

    if(this.imageProject.length !== 0) {
      const bannerPayload = this.cloudinaryRequestFormatter(this.imageProject[0]);
      let bannerResponse: any = await this.sentToCloudinary(bannerPayload);
      console.log('Banner Response', bannerResponse);

      this.projectForm.get('project_image_url')?.patchValue(bannerResponse.secure_url);
      this.projectForm.get('project_image_url')?.updateValueAndValidity();
    }

    if(this.sponsorImages.length !== 0) {
      const imageUrls: any = [];

      for(let file of this.sponsorImages) {
        let sponsorImagePayload = this.cloudinaryRequestFormatter(file);
        let sponsorImagesResponse: any = await this.sentToCloudinary(sponsorImagePayload);
        console.log('Sponsor Response', sponsorImagesResponse);

        imageUrls.push(sponsorImagesResponse.secure_url)
      }

      this.projectForm.get('sponsor_images_url')?.patchValue(imageUrls);
      this.projectForm.get('sponsor_images_url')?.updateValueAndValidity();

    }

    if(this.partnersImages.length !== 0) {
      const imageUrls: any = [];

      for(let file of this.partnersImages) {
        let partnerImagePayload = this.cloudinaryRequestFormatter(file);
        let partnerImageResponse: any = await this.sentToCloudinary(partnerImagePayload);
        console.log('Partner Response', partnerImageResponse);

        imageUrls.push(partnerImageResponse.secure_url);
      }

      this.projectForm.get('partners_images_url')?.patchValue(imageUrls);
      this.projectForm.get('partners_images_url')?.updateValueAndValidity();
    }

    this.submitHandler();
    this.showSpinner = false;
  }


  cloudinaryRequestFormatter(payload: any) {
    const cloudinaryFormData = new FormData();
    cloudinaryFormData.append('file', payload);
    cloudinaryFormData.append('upload_preset', 'vmdo-project');
    cloudinaryFormData.append('cloud_name', 'kaeyros-cloudinary');

    console.log('FORM DATA cloudinary', cloudinaryFormData);

    return cloudinaryFormData;
  }

  submitHandler() {
    const formValue = this.projectForm.value;
    console.log('This is formValue', formValue);

    const project: Project = {
      title: formValue['title'],
      content: formValue['content'],
      start_date: formValue['start_date'],
      end_date: formValue['end_date'],
      location: formValue['location'],
      project_icon_url: formValue['project_icon_url'] || ' ',
      project_image_url: formValue['project_image_url'] || ' ',
      sponsor_images_url: formValue['sponsor_images_url'] || [''],
      partners_images_url: formValue['partners_images_url'] || [''],
      lead: formValue['director'],
      code: formValue['code'],
      partners_images_urls: formValue['partners_images_urls'],
    };
    console.log(project);

    console.log("The project to be submitted", project);
    this.projectService.createProject(project).subscribe(
      (response) => {
        this.projectService.getAllProjects();
        this.projectService.emitProjectSubject();
        console.log(response);
        this.router.navigate([`/projects/${response.id}`]);
      },
      (error: HttpErrorResponse) => {
        console.error(`An error occured: ${error.message}`);
      }
    );
  }




  get contentControl() {
    return this.projectForm.controls['content'] as FormControl;
  }

  // UPLOAD LOGO PROJECT
  onSelectLogo(event: any) {
    // Only allow one file, take the first one if multiple are selected
    if (event.addedFiles && event.addedFiles.length > 0) {
      this.logoFile = [event.addedFiles[0]]; // Only keep the first file

      const file = this.logoFile[0];
      if (file) {
        this.previewLogoProject = '';
        this.previewLogoProjectTogggle = true;
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.previewLogoProject = e.target.result;
        };

        reader.readAsDataURL(file);
      }
    }
  }

  onRemoveLogo(event: any) {
    this.logoFile = []; // Clear the array instead of splicing
    this.previewLogoProject = '';
  }


  // UPLOAD IMAGE PROJECT
  onSelectImageProject(event: any) {
    // Only allow one file, take the first one if multiple are selected
    if (event.addedFiles && event.addedFiles.length > 0) {
      this.imageProject = [event.addedFiles[0]]; // Only keep the first file

      const file = this.imageProject[0];
      if (file) {
        this.previewProjectImage = '';
        this.previewProjectImageTogggle = true;
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.previewProjectImage = e.target.result;
        };

        reader.readAsDataURL(file);
      }
    }
  }

  onRemoveImageProject(event: any) {
    this.imageProject = []; // Clear the array instead of splicing
    this.previewProjectImage = '';
  }

  // UPLOAD SPONSOR IMAGE PROJECT
  onSelectSponsorImage(event: any) {
    if (this.sponsorImages.length < 3) {
      this.sponsorImages.push(...event.addedFiles);
    } else {
      this.sponsorImages.splice(1, 1);
      this.sponsorImages.push(...event.addedFiles);
    }

    const files = this.sponsorImages;

    let reader = new FileReader();
    let file;
    for (let i = 0; i < files.length; i++) {
      ((file) => {
        var reader = new FileReader();
        reader.onload = (file) => {
          this.previewSponsorImage[i] = reader.result;
          this.previewSponsorImageTogggle = true;
        };
        reader.readAsDataURL(file);
      })(files[i]);
    }

    console.log('Preview sponsor Images', this.previewSponsorImage);
  }

  // UPLOAD PARTNERS IMAGE PROJECT
  onSelectPartnersImage(event: any) {
    if (this.partnersImages.length < 6) {
      this.partnersImages.push(...event.addedFiles);
    } else {
      this.partnersImages.splice(1, 1);
      this.partnersImages.push(...event.addedFiles);
    }

    const files = this.partnersImages;

    let reader = new FileReader();
    let file;
    for (let i = 0; i < files.length; i++) {
      ((file) => {
        var reader = new FileReader();
        reader.onload = (file) => {
          this.previewParnersImage[i] = reader.result;
          this.previewPartnersImageTogggle = true;
        };
        console.log(this.previewParnersImage)
        reader.readAsDataURL(file);
      })(files[i]);
    }

  }
 /*  onSelectPartnersImage(event: any) {
    if (this.partnersImages.length < 6) {
      for (const file of event.addedFiles) {
        if (!this.partnersImages.includes(file)) {
          this.partnersImages.push(file);
        }
      }
    } else {
      this.partnersImages.splice(1, 1);
      for (const file of event.addedFiles) {
        if (!this.partnersImages.includes(file)) {
          this.partnersImages.push(file);
        }
      }
    }
    // Affichage des prévisualisations d'images
    const files = this.partnersImages;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();
      reader.onload = () => {
        this.previewParnersImage[i] = reader.result as string;
        this.previewPartnersImageTogggle = true;
      };
      reader.readAsDataURL(file);
    }
  } */

  // This is to remove sponsors images
  onRemoveSponsorImage(event: any) {
    this.sponsorImages.splice(this.sponsorImages.indexOf(event), 1);
    this.previewSponsorImage.splice(this.previewSponsorImage.indexOf(event), 1);
  }

  // This is to remove Partners images
  onRemoveParnersImages(event: any) {
    this.partnersImages.splice(this.partnersImages.indexOf(event), 1);
    this.previewParnersImage.splice(this.partnersImages.indexOf(event), 1);
  }

  sentToCloudinary(data: any) {
    return new Promise((resolve, reject) => {
      this.uploadService.uploadImage(data).subscribe(
        (response) => {
          console.log('Cloudinary Response', response);
          resolve(response);
        },
        (error) => {
          reject();
        }
      );
    });
  }

  // carry this code into a helper service later
  convertStringToArray(inputString: any) {
    const trimmedString = inputString.trim();

    // Check if the string starts and ends with square brackets
    if (trimmedString.startsWith('[') && trimmedString.endsWith(']')) {
      // Remove the square brackets
      const stringWithoutBrackets = trimmedString.slice(1, -1);

      // Split the remaining string by commas
      const stringArray = stringWithoutBrackets.split(',');

      // Trim and wrap each element in single quotes
      const resultArray = stringArray.map(
        (element: any) => `${element.trim().slice(1, -1)}`
      );

      return resultArray;
    } else {
      console.error('Input is not in the expected format.');
      return [];
    }
  }
}
